import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

var state = {
  cardTable: "",
  activityTable: "",
  jobNumber: "",
  admin: true,
  login: true
};

const actions = {
  SetCardTable: ({ //处理你要干什么，异步请求，判断，流程控制
    commit
  }) => {
    commit('SetCardTable')
  },
  SetActivityTable: ({ //处理你要干什么，异步请求，判断，流程控制
    commit
  }) => {
    commit('SetActivityTable')
  },
  SetJobNumber: ({ //处理你要干什么，异步请求，判断，流程控制
    commit
  }) => {
    commit('SetJobNumber')
  },
  SetAdmin: ({ //处理你要干什么，异步请求，判断，流程控制
    commit
  }) => {
    commit('SetAdmin')
  },
  SetLogin: ({ //处理你要干什么，异步请求，判断，流程控制
    commit
  }) => {
    commit('SetLogin')
  },
};
const mutations = {
  SetCardTable(state, fn) {
    state.cardTable = fn;
  },
  SetActivityTable(state, fn) {
    state.orderTable = fn;
  },
  SetJobNumber(state, data) {
    state.jobNumber = data;
  },
  SetAdmin(state, data) {
    state.admin = data;
  },
  SetLogin(state, data) {
    state.login = data;
  },
}
const getters = {
  cardTable(state) {
    return state.cardTable;
  },
  activityTable(state) {
    return state.activityTable;
  },
  jobNumber(state) {
    return state.jobNumber;
  },
  admin(state) {
    return state.admin;
  },
  login(state) {
    return state.login;
  }

};
export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});



// WEBPACK FOOTER //
// ./src/store.js